// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_404-module--pageContainer--s-lyu","pageText":"_404-module--pageText--2OOO3"};